module.exports = __webpack_public_path__ + "img/blog-footer-abstract.1888772.svg";